/* eslint-disable import/prefer-default-export */
import styled from 'styled-components'

export const OpModelStyled = styled.button`
  grid-area: opModel;
  width: auto;
  cursor: pointer;
  background-color: transparent;
  border: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 100%;
  overflow: hidden;

  .location {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: var(${({ color }) => color}, inherit);

    > span:last-child {
      margin-right: 0;
    }
  }
`
